import React, { useEffect, useState } from 'react';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import propTypes from 'prop-types';
import { ORGANIZATIONS } from '../../constants/routes';
import { actionTypes } from 'redux-firestore';
import { useSelector } from 'react-redux';
import {
  AccountCircle,
  ArrowRight,
  Delete,
  Edit,
  ExitToApp,
  // RemoveRedEye,
  MenuOpen,
} from '@mui/icons-material';
import { Avatar, Box, ClickAwayListener, Divider, Typography } from '@mui/material';
import { lastIndexOf } from 'lodash';
import useRoutes from '../../hooks/useRoutes';
import ClientSelector from '../../shared/ClientSelector/ClientSelector';
import collections from '../../constants/FirestoreCollections';

const useStyles = (small) =>
  makeStyles((theme) => ({
    adminRef: {
      fontSize: theme.sizes.sm.t1,
      color: '#ccc',
    },
    avatar: {
      color: 'white',
      background: theme.palette.secondary.main,
      '&:hover': {
        background: theme.palette.secondary.light,
      },
    },
    rightPanel: {
      position: 'absolute',
      zIndex: 2,
      top: 0,
      right: 0,
      height: '100dvh',
      backgroundColor: theme.palette.black.main,
      transition: 'width .3s',
      overflowY: 'hidden',
    },
    closeIcon: {
      width: 50,
      height: 50,
      color: theme.palette.white.main,
    },
    itemsBox: {
      paddingBlock: 16,
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        width: '1em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
    sectionItem: {
      width: '100%',
      cursor: 'pointer',
      userSelect: 'none',
      transition: 'all .3s',
      '&:hover': {
        backgroundColor: theme.palette.black.dark,
        color: theme.palette.primary.main,
        transform: 'scale(1.1)',
      },
      padding: 8,
      color: theme.palette.white.main,
      minWidth: '200px',
    },
    profileBox: {
      marginLeft: 16,
      width: 40,
      height: 40,
      borderRadius: '3rem',
      position: 'relative',
    },
    profileBoxIconEdit: {
      color: theme.palette.white.main,
      cursor: 'pointer',
    },
    profileBoxIconDelete: {
      color: theme.palette.white.main,
      position: 'relative',
      marginLeft: 16,
      cursor: 'pointer',
    },
    inputFile: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: '3rem',
      opacity: 0,
    },
    profileBoxFilter: {
      display: 'flex',
      position: 'absolute',
      minWidth: '100%',
      height: '100%',
      borderRadius: '3rem',
      background: 'rgba(0,0,0,.4)',
      paddingInline: 4,
      zIndex: 3,
      opacity: 0,
      '&:hover': {
        opacity: 1,
      },
    },
    profileButtonImg: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '3rem',
    },
    profileButton: {
      marginLeft: 16,
      width: 50,
      height: 50,
      borderRadius: '3rem',
    },
    details: {
      color: theme.palette.white.main,
    },
    detail: {
      fontSize: theme.sizes.sm.t1,
    },
  }));

function AccountMenu(props) {
  const classes = useStyles()();
  const { open, setOpen } = props;
  const history = useHistory();
  const firebase = useFirebase();
  const [image, setImage] = useState();
  const routes = useRoutes();
  const profile = useSelector((state) => state.firebase.profile);
  const firestore = useFirestore();

  function handleLogout() {
    return firebase.logout().then(() => {
      firebase.dispatch({
        type: actionTypes.CLEAR_DATA,
      });
      history.push('/');
    });
  }

  function goTo(path) {
    setOpen(false);
    history.push(path);
  }

  useEffect(() => {
    setImage(profile.image);
  }, [profile.image]);

  useEffect(() => {
    if (profile && profile.image) {
      setImage(profile.image);
    }
  }, []);

  const handleChangeFile = (e) => {
    if (!e || !e.target || !e.target.files || e.target.files.length === 0) return;
    // eslint-disable-next-line no-undef
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setImage(reader.result);
      // eslint-disable-next-line no-unused-vars
      const uid =
        (profile && profile.token && profile.token.claims && profile.token.claims.user_id) || '';

      const ref = firebase.storage().ref();

      if (profile && profile.image) {
        const lastIndex = lastIndexOf(image.split(''), '/');
        let urlToRemove = image.slice(lastIndex + 1, image.indexOf('?'));
        // eslint-disable-next-line no-console
        urlToRemove = decodeURIComponent(urlToRemove);
        var desertRef = ref.child(urlToRemove);
        desertRef
          .delete()
          .then(() => {})
          .catch(() => {});
      }

      const imageInfo = file;
      const random = Math.floor(Math.random() * 10000);
      const route = `users/${random}-${imageInfo.name}`;
      ref
        .child(route)
        .put(imageInfo)
        .then(() => {
          ref
            .child(route)
            .getDownloadURL()
            .then((res) => {
              if (uid) {
                firestore.collection(collections.users).doc(uid).update({ image: res });
              }
            });
        });
    };
    reader.readAsDataURL(file);
  };

  const handleDelete = () => {
    const uid =
      (profile && profile.token && profile.token.claims && profile.token.claims.user_id) || '';
    if (uid) {
      firestore.collection(collections.users).doc(uid).update({ image: '' });
    }
  };

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');

  return (
    <ClickAwayListener
      onClickAway={(event) => {
        open && setOpen(false);
      }}
    >
      <Box
        className={classes.rightPanel}
        display="flex"
        flexDirection="column"
        sx={{ userSelect: 'none', width: open ? '300px' : 0 }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box className={classes.profileBox}>
            <Box
              className={classes.profileBoxFilter}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Box>
                <input onChange={handleChangeFile} className={classes.inputFile} type="file" />
                <Edit className={classes.profileBoxIconEdit} />
              </Box>
              <Delete onClick={handleDelete} className={classes.profileBoxIconDelete} />
            </Box>
            {image ? (
              <img className={classes.profileButtonImg} src={image} />
            ) : (
              <Avatar className={classes.avatar}>
                <AccountCircle />
              </Avatar>
            )}
          </Box>
          <ArrowRight className={classes.closeIcon} onClick={() => setOpen(false)} />
        </Box>
        {isAdmin && <ClientSelector closeMenu={() => setOpen(false)} />}
        <Box
          className={classes.itemsBox}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          px={2}
        >
          {routes &&
            routes
              .filter((route) => !route.adminRoutes)
              .map((route) => (
                <Box
                  key={route.path}
                  className={classes.sectionItem}
                  display="flex"
                  alignItems="center"
                  onClick={() => goTo(route.path)}
                >
                  {route.icon}
                  <Box ml={1}>{route.label}</Box>
                </Box>
              ))}
          <Box
            className={classes.sectionItem}
            display="flex"
            alignItems="center"
            onClick={handleLogout}
          >
            <ExitToApp />
            <Box ml={1}>Salir</Box>
          </Box>
          {isAdmin && (
            <Box py={1} width="100%">
              <Divider />
              <Box mt={1} display="flex" justifyContent="center">
                <Typography className={classes.adminRef}>only admins</Typography>
              </Box>
            </Box>
          )}
          {isAdmin && (
            <Box
              className={classes.sectionItem}
              display="flex"
              alignItems="center"
              onClick={() => goTo(ORGANIZATIONS)}
            >
              <MenuOpen />
              <Box ml={1}>Clientes</Box>
            </Box>
          )}
          {routes
            .filter((route) => route.adminRoutes)
            .map((route) => (
              <Box
                key={route.path}
                className={classes.sectionItem}
                display="flex"
                alignItems="center"
                onClick={() => goTo(route.path)}
              >
                {route.icon}
                <Box ml={1}>{route.label}</Box>
              </Box>
            ))}
          <Box marginY={2} width="100%">
            <Divider />
          </Box>
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            className={classes.details}
          >
            <Typography className={classes.detail}>Email: {profile.email}</Typography>
          </Box>
        </Box>
      </Box>
    </ClickAwayListener>
  );
}

const Props = {
  open: propTypes.bool.isRequired,
  setOpen: propTypes.func.isRequired,
};

AccountMenu.propTypes = Props;

export default AccountMenu;
